export default __webpack_public_path__ + "static/media/THSarabun-Bold.295f1fb2.ttf";